import { Box, BoxProps, Button, Text } from 'grommet';
import { Certificate, DocumentUpload, Trash } from 'grommet-icons';
import { TRightId } from 'lib/api';
import { observer } from 'mobx-react-lite';
import { useRightStore } from 'src/context';
import { getAnimProps } from 'src/utils/styling';
import { AddNewButton } from '../AddNewButton';
import { Divider } from '../Divider';
import { SaveStatus, SaveStatusIndicator } from '../SaveStatusIndicator';

export type LicensingRightsHeaderProps = {
  onCreate: () => void;
  onUpload: () => void;
  onDelete: () => void;
  selected: TRightId[];
  height?: BoxProps['height'];
};

export const LicensingRightsHeader = observer(
  ({
    onCreate,
    onUpload,
    onDelete,
    selected,
    height = {
      min: '92px',
      max: '92px',
    },
  }: LicensingRightsHeaderProps) => {
    /** Context **/
    const rightStore = useRightStore();

    /** Computed **/
    const saveStatus = rightStore.isSaving ? SaveStatus.Saving : SaveStatus.Saved;

    /** Render **/
    return (
      <Box
        background="light-3"
        direction="row"
        align="center"
        justify="between"
        height={height}
        gap="medium"
        style={{ zIndex: 1 }}
        elevation="small"
        pad={{ right: 'medium' }}
      >
        <Box direction="column" gap="xsmall">
          <Box
            margin={{ left: 'medium' }}
            animation={getAnimProps(0, 'slideUp')}
            justify="start"
            direction="row"
            pad={{ right: 'none' }}
          >
            <Text truncate size="xlarge">
              Licensing & Rights
            </Text>
          </Box>
          <Divider height="2px" animation={{ type: 'slideRight', size: 'xlarge' }} />
          {saveStatus && (
            <Box align="end" animation={getAnimProps(0, 'slideDown')} pad={{ right: 'none' }}>
              <SaveStatusIndicator saveStatus={saveStatus} boxProps={{ margin: 'none' }} />
            </Box>
          )}
        </Box>
        <Box direction="row" gap="small">
          <AddNewButton onClick={onUpload} icon={<DocumentUpload />} tipText="Upload License/Rights Document" />
          <AddNewButton onClick={onCreate} icon={<Certificate />} tipText="New Licensing & Rights" />
          <Button
            disabled={selected.length === 0}
            onClick={onDelete}
            icon={<Trash color="status-critical" />}
            tip="Remove Right"
          />
        </Box>
      </Box>
    );
  }
);
